<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">申請画面</h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div
        v-if="errorMessage"
        class="error-message"
        style="white-space: pre-wrap"
      >
        {{ errorMessage }}
      </div>
      <table style="width: 100%">
        <thead>
          <th style="width: 12%"></th>
          <th style="width: 15%"></th>
          <th style="width: 12%"></th>
          <th style="width: 15%"></th>
          <th style="width: 12%"></th>
          <th style="width: 15%"></th>
          <th style="width: 17%"></th>
        </thead>
        <tbody>
          <tr style="height: 40px">
            <td class="form-control-title">申請No.</td>
            <td>
              <label>{{ applicationData.appNo }}</label>
            </td>
            <td class="form-control-title">申請日</td>
            <td>
              <label>{{ applicationData.appDate }}</label>
            </td>
            <td class="form-control-title">ステータス</td>
            <td>
              <select
                v-model="applicationData.appStatusKbn"
                class="form-control"
                :disabled="!enableEdit"
              >
                <option
                  v-for="item in statusList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.text }}
                </option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
      <table style="width: 100%; margin-top: -5px">
        <thead>
          <th style="width: 12%"></th>
          <th style="width: 21%"></th>
          <th style="width: 21%"></th>
          <th style="width: 21%"></th>
          <th style="width: 10%"></th>
          <th style="width: 15%"></th>
        </thead>
        <tbody>
          <tr>
            <td class="form-control-title">ｱﾄﾞﾚｽ＿申請者名</td>
            <td>
              <label>{{ applicationData.appUser }}</label>
            </td>
          </tr>
          <tr>
            <td class="form-control-title">申請タイトル</td>
            <td colspan="3">
              <label>{{ applicationData.appTitle }} </label>
            </td>
          </tr>
          <tr>
            <td class="form-control-title">対応希望日</td>
            <td>
              <label>{{ applicationData.wishDate }}</label>
            </td>
          </tr>
          <tr>
            <td class="form-control-title">申請種別</td>
            <td colspan="2">
              <select
                class="form-control"
                v-model="applicationData.appCategoryId"
                disabled="true"
              >
                <option
                  v-for="item in appCategoryList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.text }}
                </option>
              </select>
            </td>
          </tr>
          <tr
            v-if="
              applicationData.osgCategoryID ||
              applicationData?.osgTempFileList.length > 0
            "
          >
            <td></td>
            <td colspan="3">
              <div class="form-inline flex-container">
                <div class="form-group" style="width: 100%; margin-right: 1rem">
                  <fieldset>
                    <legend>参考：関連情報</legend>
                    <table>
                      <thead>
                        <th style="width: 25%"></th>
                        <th style="width: 75%"></th>
                      </thead>
                      <tbody>
                        <tr v-if="applicationData.osgCategoryID">
                          <td class="form-control-title">ワンストップガイド</td>
                          <td>
                            <router-link
                              class="com_link1"
                              :to="`/${
                                applicationData.osgDetailPath
                              }/categoryId/${
                                applicationData.osgCategoryID
                              }/contentsId/${
                                applicationData.osgContentsId
                              }/ismodal/${true}`"
                              target="_blank"
                              @click="
                                regLinkClick(
                                  `/${
                                    applicationData.osgDetailPath
                                  }/categoryId/${
                                    applicationData.osgCategoryID
                                  }/contentsId/${
                                    applicationData.osgContentsId
                                  }/ismodal/${true}`
                                )
                              "
                              >{{ applicationData.osgContentsTitle }}
                            </router-link>
                          </td>
                        </tr>
                        <tr v-if="applicationData?.osgTempFileList.length > 0">
                          <td class="form-control-title">関連資料</td>
                          <td class="osg-files-cell">
                            <div
                              v-for="tempFile in applicationData?.osgTempFileList"
                              :key="tempFile.rowNo"
                              class="osg-file-row"
                            >
                              <a
                                :href="`/${tempFile.tempFilePath}`"
                                class="com_link1"
                                target="_blank"
                                @click="regFileLinkClick(tempFile.tempFilePath)"
                                >{{ tempFile.tempFileName }}</a
                              >
                              <span v-if="tempFile.tempFileSize" class="sub1">
                                ({{ tempFile.tempFileSize }})</span
                              >
                              <a
                                v-if="tempFile.tempFileName"
                                href="#"
                                class="com_dl_button2 osg-file-row__btn"
                                @click.prevent="
                                  downloadFiles(tempFile.tempFileName)
                                "
                                ><span>ダウンロード</span></a
                              >
                            </div>
                          </td>
                        </tr>
                        <tr v-if="applicationData?.osgTempFileList.length > 0">
                          <td></td>
                          <td>
                            <a
                              href="#"
                              class="com_dl_button1"
                              @click.prevent="downloadFiles('')"
                              ><span>全データダウンロード</span></a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </fieldset>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="form-control-title">添付資料</td>
            <td colspan="3" class="osg-files-cell">
              <div class="file-upload">
                <button
                  v-if="enableEdit"
                  class="btn btn-primary btn-sm"
                  @click="
                    onContentsFileUpload(AppMgtConstants.TRIGGER_TEMP_FILE)
                  "
                >
                  +
                </button>
                <input
                  type="file"
                  :accept="tempFileExtensions.join(',')"
                  @change="handleContentsFileSelected"
                  ref="tempFileInput"
                  style="display: none"
                  :readonly="!enableEdit"
                />
              </div>
              <div
                v-for="item in applicationData.appTempFileList"
                :key="item.rowNo"
                class="osg-file-row"
              >
                <button
                  v-if="enableEdit"
                  class="btn btn-danger btn-sm"
                  @click="
                    onRemoveContentsFile(
                      item.rowNo,
                      AppMgtConstants.TRIGGER_TEMP_FILE
                    )
                  "
                >
                  -
                </button>
                {{ item.fileName }}
                <span v-if="item.tempFileSize" class="sub1">
                  ({{ item.tempFileSize }})</span
                >
                <a
                  v-if="item.fileName && !item.isUpload"
                  href="#"
                  class="com_dl_button2 osg-file-row__btn"
                  @click.prevent="downloadTempFiles(item.fileName)"
                  ><span>ダウンロード</span></a
                >
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4">補足（注意事項）</td>
          </tr>
          <tr>
            <td class="form-control-title">対象AGコード</td>
            <td colspan="2">
              <input
                type="text"
                id="txtTergetAg"
                maxlength="50"
                class="form-control"
                v-model="applicationData.targetAgCode"
                :readonly="!enableEdit"
              />
            </td>
          </tr>
          <tr>
            <td class="form-control-title">対象企業ID</td>
            <td>
              <input
                type="text"
                id="txtCompanyId"
                maxlength="20"
                class="form-control"
                v-model="applicationData.targetCompanyId"
                :readonly="!enableEdit"
              />
            </td>
          </tr>
          <tr>
            <td class="form-control-title">対応担当者</td>
            <td>
              <input
                type="text"
                id="txtOperateUser"
                maxlength="20"
                class="form-control"
                v-model="applicationData.operateUser"
                :readonly="!enableEdit"
              />
            </td>
          </tr>
          <tr>
            <td class="form-control-title">カウネット営業担当</td>
            <td>
              <input
                type="text"
                id="txtKaunetUser"
                maxlength="20"
                class="form-control"
                v-model="applicationData.kaunetUser"
                :readonly="!enableEdit"
              />
              <label>{{ applicationData.kaunetUser }}</label>
            </td>
          </tr>
          <tr>
            <td class="form-control-title">依頼内容</td>
          </tr>
          <tr>
            <td colspan="6">
              <textarea
                id="txtMemo"
                class="resizable-textarea"
                rows="5"
                maxlength="1000"
                v-model="applicationData.appMemo"
                :readonly="!enableEdit"
              ></textarea>
            </td>
          </tr>
          <tr>
            <td class="form-control-title">カウネット返信欄</td>
          </tr>
          <tr>
            <td colspan="6">
              <textarea
                id="txtKaunetComment"
                class="resizable-textarea"
                rows="5"
                maxlength="1000"
                v-model="applicationData.kaunetComment"
                :readonly="!enableEdit"
              ></textarea>
            </td>
          </tr>
          <tr>
            <td class="form-control-title">内部メモ欄</td>
            <td>※申請者には表示されません</td>
          </tr>
          <tr>
            <td colspan="6">
              <textarea
                id="txtKaunetComment"
                class="resizable-textarea"
                rows="5"
                maxlength="1000"
                v-model="applicationData.kaunetMemo"
                :readonly="!enableEdit"
              ></textarea>
            </td>
          </tr>
        </tbody>
      </table>

      <table>
        <thead>
          <th style="width: 30%"></th>
          <th style="width: 70%"></th>
        </thead>
        <tbody>
          <td style="text-align: left">
            <button
              v-if="enableEdit"
              type="button"
              name="btnSave"
              class="btn btn-footer btn-danger"
              @click="onDelete"
            >
              削除
            </button>
          </td>
          <td style="text-align: right">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="onBack"
            >
              戻る
            </button>
            <button
              v-if="enableEdit"
              type="button"
              name="btnApplication"
              class="btn btn-footer btn-success"
              @click="onSubmit"
            >
              登録/返信
            </button>
            <button
              v-if="enableEdit"
              type="button"
              name="btnApplication"
              class="btn btn-footer-large btn-success"
              @click="sendEscalationMail"
            >
              エスカレーション
            </button>
          </td>
        </tbody>
      </table>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
  <!-- メールアドレス指定モーダル -->
  <EmailAddressModal
    v-if="showEmailModal"
    @ok="handleEmailModalOk"
    @cancel="handleEmailModalCancel"
  />
</template>

<script lang="ts">
import { AxiosError } from "axios";
import * as tus from "tus-js-client"; // * as tus を使ってインポート
import { defineComponent, onMounted, ref, computed, PropType } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import {
  formatMessage,
  outputDebugLogs,
  getTargetDate,
  scrollToTop,
  isTokenAlive,
  regLinkClickLog,
  checkFileName,
  commonHandleAxiosError,
  hasNoGaiji,
  sanitizeInput,
  regFileLinkClickLog,
  formatDispDate,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import apiDownloadClient from "@/util/apiClientDownload";
import { useProcessingStore } from "../../store/useProcessingStore";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import EmailAddressModal from "../layout/EmailAddressModal.vue";

interface appMgtParam {
  agCode: string;
  userId: string;
  daihyoCode: string;
  applicationNo: string;
  processingMode: string;
  appSearchCond: appSearchCond;
  itemsPerPage: number;
  currentPage: number;
  listProcessingMode: string;
}

/**
 * 申請情報検索条件
 */
interface appSearchCond {
  appDateFrom: string;
  appDateTo: string;
  categoryId: string;
  status: string;
  keyword: string;
  wishDate: string;
  disableFinised: boolean;
  appAgCode: string;
  operateUser: string;
  kaunetUser: string;
}

interface applicationData {
  appNo: string; // 申請No.
  appDate: string; // 申請日
  appStatusKbn: string; // ステータス
  appStatus: string; // ステータス名
  appUser: string; // 申請者
  appAgCode: string; // 申請AGコード
  appTitle: string; // タイトル
  wishDate: string; // 希望納期
  appCategoryId: string; // 申請種別ID
  osgCategoryID: string; // ワンストップガイドカテゴリID
  osgContentsId: string; // ワンストップガイドコンテンツID
  osgContentsTitle: string; // ワンストップガイドコンテンツタイトル
  osgDetailPath: string; // ワンストップガイドURL
  osgTempFileList: OsgTempFile[]; // ワンストップガイド関連資料
  appTempFileList: ContentsFile[]; // 申請添付資料
  targetAgCode: string; // 対象AGコード
  targetCompanyId: string; // 対象企業ID
  appMemo: string; // 申請内容
  kaunetComment: string; // カウネット返信欄
  kaunetMemo: string; // カウネットメモ欄
  kaunetUser: string; // カウネット営業担当
  operateUser: string; // カウネット対応担当
}

// 関連資料ファイルのinterface
interface OsgTempFile {
  rowNo: number;
  tempFilePath: string;
  tempFileName: string;
  tempFileSize: string;
}

// 添付ファイルのinterface
interface ContentsFile {
  rowNo: number;
  tempFilePath: string;
  fileName: string;
  tempFileSize: string;
  file: File | null;
  isUpload: boolean;
  fileUrl: string | null;
}

interface selectItem {
  value: string;
  text: string;
}

interface EmailAddresses {
  to: string[];
  cc: string[];
  bcc: string[];
}

class AppMgtConstants {
  // API-URL
  static readonly API_URL_INITIAL_DISPLAY =
    "/api/ApplicationMgtKaunet/getAppFormInitialData";
  static readonly API_URL_UPDATE_NOTIFICATION =
    "/api/NotificationManagement/updNotification";
  static readonly API_URL_UPDATE =
    "/api/ApplicationMgtKaunet/updApplicationData";
  static readonly API_URL_DELETE =
    "/api/ApplicationMgtKaunet/deleteApplicationData";
  static readonly API_URL_CANCEL =
    "/api/ApplicationMgtAg/cancelApplicationData";
  static readonly API_URL_UPDATE_SET_EDTING =
    "/api/ApplicationMgtCommon/setEditing";
  static readonly API_URL_UPDATE_RELEASE_EDTING =
    "/api/ApplicationMgtCommon/releseEditing";

  static readonly API_GET_CATEGORY_DATA =
    "/api/ApplicationMgtCommon/getAppCagetoryData";

  static readonly API_GET_LATEST_UPD_DATE =
    "/api/ApplicationMgtCommon/getLatestUpdDate";

  // イベント発火元
  static readonly TRIGGER_TEMP_FILE = "tempFile"; // 添付ファイル
}

export default defineComponent({
  name: "ApplicationMGKaunetComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    LoadingOverlay,
    EmailAddressModal,
  },
  props: {
    appNo: {
      type: String as PropType<string>,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const { getCategoryIdByName } = useUserParmitionStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const paramAgCode = ref(""); // パラメータのAGコード
    const paramUserId = ref(""); // パラメータのユーザーID
    const paramDaihyoCode = ref(""); // パラメータの代表コード
    const paramApplicationNo = ref(""); // パラメータの申請ID
    const processingMode = ref(""); // パラメータの処理モード
    const listProcessingMode = ref(""); // パラメータの処理モード
    const appCategoryList = ref<selectItem[]>([]);
    const statusList = ref<selectItem[]>([]);
    const isLoading = ref(false);
    const { logoutUser } = useUserStore();

    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const userName = ref(""); // ユーザー名
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const pseudoDaihyoCode = ref(""); // 疑似ログイン代表コード
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const serchDaihyoCode = ref(""); // 検索用代表コード
    const daihyoCode = ref(""); // 代表コード
    const categoryId = ref<string | null>(null); // 申請管理（申請者）のカテゴリID
    const txtKaunetComment = ref<HTMLInputElement | null>(null);
    const uploadProgress = ref<number | null>(null); //
    const dispDateTime = ref(""); // 表示時の日時
    const beforeAppStatus = ref(""); // 変更前のステータス区分
    const loginEmailAddress = ref(""); // ログインユーザーのメールアドレス

    // モーダル関連
    const isProcessing = ref(false);
    const showEmailModal = ref(false);
    const emailResult = ref<EmailAddresses | null>(null);
    let emailModalResolver: ((value: EmailAddresses | null) => void) | null =
      null;

    let maxFileSize = 0; // ファイルアップロードの最大サイズ

    // アップロード関連
    const tempFileInput = ref<HTMLInputElement | null>(null);
    let uploadTarget = ref("");
    const tempFileExtensions = [".pdf", ".docx", ".xlsx", ".txt", ".pptx"]; // 添付ファイルの拡張子

    const applicationData = ref<applicationData>({
      appNo: "",
      appDate: "",
      appStatusKbn: "",
      appStatus: "",
      appUser: "",
      appAgCode: "",
      appTitle: "",
      wishDate: "",
      appCategoryId: "",
      osgCategoryID: "",
      osgContentsId: "",
      osgContentsTitle: "",
      osgDetailPath: "",
      osgTempFileList: [], // ワンストップガイド関連資料
      appTempFileList: [], // 申請添付資料
      targetAgCode: "",
      targetCompanyId: "",
      appMemo: "",
      kaunetComment: "",
      kaunetUser: "",
      kaunetMemo: "", // カウネットメモ欄
      operateUser: "", // カウネット対応担当
    });

    // 一覧画面へ戻る際の検索条件保持関連
    const currentPage = ref(1); // 現在ページ
    const itemsPerPage = ref(20); // 1ページに表示する最大件数
    const appSearchCond = ref<appSearchCond>({
      appDateFrom: "",
      appDateTo: "",
      categoryId: "",
      status: "",
      keyword: "",
      wishDate: "",
      disableFinised: false,
      appAgCode: "",
      operateUser: "",
      kaunetUser: "",
    });

    /**
     * 削除表示判定
     */
    const isVisibleCancel = computed(() => {
      outputDebugLogs("appStatus:" + beforeAppStatus.value);

      // 閲覧モードなら削除ボタン非表示
      if (processingMode.value == AppConstants.EDIT_MODE_PREVIEW) {
        return false;
      }

      return true;
    });

    // 編集モード判定
    const enableEdit = computed(() => {
      // 閲覧モードは編集不可
      if (processingMode.value == AppConstants.EDIT_MODE_PREVIEW) {
        return false;
      }

      // スタータスがカウネット確認中なら編集可
      if (beforeAppStatus.value == AppConstants.APP_STATAS_KAUNET_CHECKING) {
        return true;
      }

      // スタータスが申請者確認中なら編集可
      if (beforeAppStatus.value == AppConstants.APP_STATAS_AG_CHECKING) {
        return true;
      }
      return false;
    });

    /**
     * 申請種別名名取得
     * @param appId イベントID
     */
    const getAppTypeName = (appId: string): string => {
      const appType = appCategoryList.value.find(
        (item) => item.value === appId
      );
      return appType?.text || "";
    };

    /**************************************
     * 初期処理
     *************************************/
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      outputDebugLogs("申請画面（申請側）初期処理");
      outputDebugLogs("パラメータの申請番号 " + props.appNo);

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // sessionStorageからパラメータ取得
        const sessionParam = sessionStorage.getItem(
          AppConstants.APPLICATION_MGT_KAUNET_SESSION_NAME
        );
        if (sessionParam) {
          // 存在する場合はパラメータを変数にセット
          const appMgtParam = JSON.parse(sessionParam) as appMgtParam;
          paramAgCode.value = appMgtParam.agCode;
          paramUserId.value = appMgtParam.userId;
          paramDaihyoCode.value = appMgtParam.daihyoCode;
          paramApplicationNo.value = appMgtParam.applicationNo;
          processingMode.value = appMgtParam.processingMode;
          currentPage.value = appMgtParam.currentPage;
          itemsPerPage.value = appMgtParam.itemsPerPage;
          appSearchCond.value = appMgtParam.appSearchCond;
          listProcessingMode.value = appMgtParam.listProcessingMode;

          // sessionStorageからパラメータ削除
          sessionStorage.removeItem(
            AppConstants.APPLICATION_MGT_KAUNET_SESSION_NAME
          );
        } else {
          if (props.appNo) {
            // 存在しない場合はURLから直接遷移
            outputDebugLogs("セッションなし URLからの直リンク");
            paramApplicationNo.value = props.appNo;
            // 編集モードは更新モード
            processingMode.value = AppConstants.EDIT_MODE_UPDATE;
          } else {
            // 存在しない場合はエラー
            outputDebugLogs("セッションなし");
            errorMessage.value = messages.ERR_SYS998;
            return;
          }
        }

        outputDebugLogs("processingMode.value:" + processingMode.value);

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          userName.value = parsedUserInfo.userName;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          daihyoCode.value = parsedUserInfo.daihyoCode;
          loginEmailAddress.value = parsedUserInfo.loginEmailAddress;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
            serchDaihyoCode.value = daihyoCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
            serchDaihyoCode.value = pseudoDaihyoCode.value;
          }
        }

        // パラメータのユーザー情報とローカルストレージのユーザー情報が
        // 一致しない場合はエラー
        // 直接遷移があるのでチェックしない
        // if (
        //   paramAgCode.value != agCode.value ||
        //   paramUserId.value != userId.value
        // ) {
        //   outputDebugLogs(
        //     "パラメータのユーザー情報とローカルストレージのユーザー情報不一致"
        //   );
        //   outputDebugLogs("paramAgCode.value：" + paramAgCode.value);
        //   outputDebugLogs("paramUserId.value：" + paramUserId.value);
        //   outputDebugLogs("agCode.value：" + agCode.value);
        //   outputDebugLogs("userId.value：" + userId.value);
        //   errorMessage.value = messages.ERR_SYS998;
        //   return;
        // }

        // 初期情報取得API
        const response = await apiAuthClient.post(
          AppMgtConstants.API_URL_INITIAL_DISPLAY,
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            daihyoCode: serchDaihyoCode.value,
            applicationNo: paramApplicationNo.value,
          }
        );

        // カテゴリリスト設定
        appCategoryList.value = response.data.categoryList;

        // 申請管理（受領者）のカテゴリIDを取得
        categoryId.value = getCategoryIdByName(
          AppConstants.CATEGORY_NAME_APP_MGT_KAUNET
        );

        // 対象AGコードの初期値はログインしているAGコード
        applicationData.value.targetAgCode = serchAgCode.value;

        // ファイルアップロードの最大サイズ
        maxFileSize = parseInt(response.data.maxFileSize || "0", 10);

        // 表示時の日時
        dispDateTime.value = response.data.dispDateTime;
        outputDebugLogs("dispDateTime:" + dispDateTime.value);

        // ステータスリスト設定
        statusList.value = response.data.statusList;

        // レスポンスから申請情報を設定する
        applicationData.value = response.data.applicationData;
        // 申請日を表示用にフォーマット
        applicationData.value.appDate = formatDispDate(
          applicationData.value.appDate
        );
        // 希望納期を表示用にフォーマット
        applicationData.value.wishDate = formatDispDate(
          applicationData.value.wishDate
        );

        // 変更前のステータス区分を保持
        beforeAppStatus.value = applicationData.value.appStatusKbn;

        //通知管理更新API
        await apiAuthClient.post(AppMgtConstants.API_URL_UPDATE_NOTIFICATION, {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          userId: serchUserId.value,
          agCode: serchAgCode.value,
          categoryId: categoryId.value,
          notificationNo: paramApplicationNo.value,
        });

        // 編集モード判定
        if (enableEdit.value) {
          // 編集可能な場合は申請管理ヘッダの編集中フラグをONにする
          await apiAuthClient.post(AppMgtConstants.API_URL_UPDATE_SET_EDTING, {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            daihyoCode: serchDaihyoCode.value,
            applicationNo: paramApplicationNo.value,
          });
        }

        // setTimeout(function () {
        //   // フォーカス設定
        //   if (txtKaunetComment.value) {
        //     txtKaunetComment.value.focus();
        //   }
        // }, 1);

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    });

    /**************************************
     * リンククリックのログを出力します
     * @param linkUrl リンクURL
     *************************************/
    const regLinkClick = (linkUrl: string) => {
      regLinkClickLog(
        linkUrl,
        userId.value,
        agCode.value,
        pseudoAgCode.value,
        pseudoUserId.value,
        applicationData.value.osgCategoryID,
        "申請画面（申請側）"
      );
    };

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // 添付ファイル関連 START
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    /**************************************
     * 添付ファイルアップロードボタン押下時
     * @param trigger
     *************************************/
    const onContentsFileUpload = (trigger: string) => {
      // イベントの発火元を保存
      uploadTarget.value = trigger;
      outputDebugLogs("onContentsFileUpload:");
      outputDebugLogs("trigger:" + trigger);
      outputDebugLogs("tempFileInput:" + tempFileInput.value);

      // イベントの発火元により処理を分岐
      switch (trigger) {
        case AppMgtConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル
          if (tempFileInput.value) {
            tempFileInput.value.click();
          }
          break;
      }
    };

    /**************************************
     * 添付ファイル選択時
     * @param event
     *************************************/
    const handleContentsFileSelected = (event: Event) => {
      contentsFileSelected(event, uploadTarget.value);
    };

    /**************************************
     * 添付ファイル選択時
     * @param event
     * @param trigger
     *************************************/
    const contentsFileSelected = (event: Event, trigger: string) => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      errorMessage.value = "";

      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      outputDebugLogs("contentsFileSelected:");

      try {
        if (file) {
          const contentsFile = {
            rowNo: getContentsFileMaxRowNo(trigger) + 1,
            tempFilePath: "",
            fileName: file.name,
            tempFileSize: formatFileSize(file.size),
            file: file,
            isUpload: true,
            fileUrl: null,
          };

          // ファイルサイズチェック
          if (!isFileSize(contentsFile.file)) {
            errorMessage.value = formatMessage(
              messages.ERR_0024,
              maxFileSize / (1024 * 1024)
            );
            scrollToTop();
            return;
          }

          let messageId = "";
          let arg = "";

          // イベントの発火元により処理を分岐
          switch (trigger) {
            case AppMgtConstants.TRIGGER_TEMP_FILE:
              // 添付ファイル

              if (!isFileExtensions(contentsFile.file, ...tempFileExtensions)) {
                // 拡張子チェック
                messageId = messages.ERR_0027;
                arg = "添付ファイル";
              } else if (
                !isFilenameDuplicate(
                  contentsFile,
                  applicationData.value.appTempFileList
                )
              ) {
                // ファイル名重複チェック
                messageId = messages.ERR_0017;
                arg = "添付ファイル名";
              } else if (!checkFileName(file.name.toLowerCase())) {
                // ファイル名チェック
                messageId = messages.ERR_0025;
                arg = "添付ファイル名";
              }

              // エラーがある場合
              if (messageId) {
                errorMessage.value = formatMessage(messageId, arg);
                scrollToTop();
                return;
              }

              applicationData.value.appTempFileList.push(contentsFile);
              break;
          }
        }
      } finally {
        // ファイルを未選択状態にする
        fileInput.value = "";
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    function formatFileSize(bytes: number): string {
      if (bytes >= 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(1) + "MB";
      } else if (bytes >= 1024) {
        return (bytes / 1024).toFixed(1) + "KB";
      } else {
        return bytes + "B";
      }
    }

    /**************************************
     * ファイルサイズチェック
     *************************************/
    const isFileSize = (file: File | null): boolean => {
      return (file?.size ?? 0) <= maxFileSize;
    };

    /**************************************
     * ファイル拡張子チェック
     * @param file ファイル
     * @param extensions 拡張子
     *************************************/
    const isFileExtensions = (
      file: File | null,
      ...extensions: string[]
    ): boolean => {
      return extensions.some((extension) =>
        file?.name.toLowerCase().endsWith(extension)
      );
    };

    /**************************************
     * ファイル名重複チェック
     * @param file ファイル
     * @param extensions 拡張子
     *************************************/
    const isFilenameDuplicate = (
      target: ContentsFile,
      contentsListFile: ContentsFile[]
    ): boolean => {
      return !contentsListFile
        .filter((contentsFile) => contentsFile.rowNo != target.rowNo)
        .some((contentsFile) => contentsFile.fileName == target.fileName);
    };

    /**
     * コンテンツファイルの最大値の行番号を返却します。
     */
    const getContentsFileMaxRowNo = (trigger: string): number => {
      let contentsFileList: ContentsFile[] = [];
      switch (trigger) {
        case AppMgtConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル
          contentsFileList = applicationData.value.appTempFileList;
          break;
      }

      if (contentsFileList.length < 1) {
        return 0;
      }
      return Math.max.apply(
        null,
        contentsFileList.map(function (contentsFile) {
          return contentsFile.rowNo;
        })
      );
    };

    /**************************************
     * ファイルダウンロード
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     *************************************/
    const downloadFiles = async (flName: string) => {
      // 何か処理中の場合は処理しない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // エラーメッセージ初期化
        errorMessage.value = "";

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // ファイルダウンロードAPI
        const response = await apiDownloadClient.post(
          "/api/download/downloadKanrenFile",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: userId.value,
            agCode: agCode.value,
            categoryId: applicationData.value.appCategoryId,
            contentId: "",
            fileName: flName,
            targetDate: getTargetDate(""),
            pseudoUserId: pseudoUserId.value,
            pseudoAgCode: pseudoAgCode.value,
            screenName: "申請管理（申請側）",
          }
        );

        // Content-Dispositionヘッダーからファイル名を取得
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "downloaded_file";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);

        // エラーメッセージを表示
        errorMessage.value = formatMessage(
          messages.ERR_SYS003,
          "ファイルダウンロード"
        );

        // スクロールを一番上に戻す
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**************************************
     * 添付ファイルダウンロード
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     *************************************/
    const downloadTempFiles = async (flName: string) => {
      // 何か処理中の場合は処理しない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // エラーメッセージ初期化
        errorMessage.value = "";

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // ファイルダウンロードAPI
        const response = await apiDownloadClient.post(
          "/api/download/downloadAppTempFile",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: userId.value,
            agCode: agCode.value,
            categoryId: applicationData.value.appCategoryId,
            contentId: "",
            fileName: flName,
            targetDate: getTargetDate(""),
            pseudoUserId: serchUserId.value,
            pseudoAgCode: serchAgCode.value,
            screenName: "虎の巻",
            daihyoCode: serchDaihyoCode.value,
            appNo: applicationData.value.appNo,
          }
        );

        // Content-Dispositionヘッダーからファイル名を取得
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "downloaded_file";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);

        // エラーメッセージを表示
        errorMessage.value = formatMessage(
          messages.ERR_SYS003,
          "ファイルダウンロード"
        );

        // スクロールを一番上に戻す
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // 添付ファイル関連 End
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // ボタン押下時処理関連 START
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    /**************************************
     * 戻るボタン押下
     *************************************/
    const onBack = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      if (enableEdit.value) {
        const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
        if (!isConfirm) {
          // いいえの場合
          return;
        }
      }

      outputDebugLogs("listProcessingMode:" + listProcessingMode.value);

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;
      try {
        if (enableEdit.value) {
          // 申請管理ヘッダの編集中フラグをOFFにする
          await apiAuthClient.post(
            AppMgtConstants.API_URL_UPDATE_RELEASE_EDTING,
            {
              systemKbn: process.env.VUE_APP_SYSTEM_KBN,
              userId: serchUserId.value,
              agCode: serchAgCode.value,
              daihyoCode: serchDaihyoCode.value,
              applicationNo: applicationData.value.appNo,
            }
          );
        }

        // sessionStorageに一覧の検索条件を設定
        sessionStorage.setItem(
          AppConstants.APPLICATION_LIST_KAUNET_SESSION_NAME,
          JSON.stringify({
            appSearchCond: appSearchCond.value,
            itemsPerPage: itemsPerPage.value,
            currentPage: currentPage.value,
            processingMode: listProcessingMode.value,
          })
        );

        // 申請状況一覧（申請側）へ遷移
        router.push({
          path: "/shinsei-kanri-kaunet",
        });
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**************************************
     * 登録/返信ボタン
     *************************************/
    const onSubmit = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // メッセージクリア
      errorMessage.value = "";
      // 入力チェック
      if (!validateInput()) {
        scrollToTop();
        return;
      }
      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // 確認ダイアログ表示
      const isConfirm = window.confirm(
        formatMessage(messages.CNF_0001, "申請情報", "登録/返信")
      );
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // ほかの人がすでに更新していないかチェック
        if (!(await checkLatestUpdDate())) {
          // 再表示確認
          const isApliedConf = window.confirm(formatMessage(messages.CNF_0009));

          if (isApliedConf) {
            // はいの場合再表示
            await formDataReroad();
            //スクロールを最上部へ
            scrollToTop();
            return;
          } else {
            // いいえの場合、処理終了
            //スクロールを最上部へ
            scrollToTop();
            return;
          }
        }

        let result = false;

        // ファイルアップロード
        // 添付ファイル
        result = await executeContentsFiles(
          applicationData.value.appTempFileList
        );

        // ファイルアップロードに失敗している場合
        if (!result) {
          scrollToTop();
          errorMessage.value = formatMessage(
            messages.ERR_SYS003,
            "ファイルアップロード"
          );
          return;
        }

        // 更新処理
        await executeUpdate();

        // モーダル表示するのでいったんローディングはOFF
        isLoading.value = false;

        // メールアドレス指定モーダルを表示
        const emailAddresses = await showEmailAddressModal();

        // ローディング再開
        isLoading.value = true;

        if (emailAddresses !== null) {
          // 決定が押された場合
          emailResult.value = emailAddresses;
          console.log("送信先メールアドレス:", emailAddresses);

          // メール送信処理
          await sendMail(emailAddresses);
        } else {
          // 通知をやめるが押された場合
          console.log("メール通知がキャンセルされました");
        }
        //isLoading.value = true;
        // 申請データ再表示
        await formDataReroad();

        //スクロールを最上部へ
        scrollToTop();
      } finally {
        showEmailModal.value = false;
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**************************************
     * 削除ボタン押下
     *************************************/
    const onDelete = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // 確認ダイアログ表示
      const isConfirm = window.confirm(
        formatMessage(messages.CNF_0001, "申請情報", "削除")
      );
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;
      try {
        // ほかの人がすでに更新していないかチェック
        if (!(await checkLatestUpdDate())) {
          // 再表示確認
          const isApliedConf = window.confirm(formatMessage(messages.CNF_0009));

          if (isApliedConf) {
            // はいの場合再表示
            await formDataReroad();
            //スクロールを最上部へ
            scrollToTop();
            return;
          } else {
            // いいえの場合、処理終了
            //スクロールを最上部へ
            scrollToTop();
            return;
          }
        }

        // 申請情報削除
        await executeDelete();

        // 申請状況一覧（申請側）へ遷移
        router.push({
          path: "/shinsei-kanri-kaunet",
        });
      } catch (error: unknown) {
        return;
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**************************************
     * 登録・更新APIのリクエストデータを返却します。
     *************************************/
    const getRequestInput = (): object => {
      return {
        systemKbn: process.env.VUE_APP_SYSTEM_KBN,
        agCode: serchAgCode.value,
        userId: serchUserId.value,
        daihyoCode: serchDaihyoCode.value,
        appNo: applicationData.value.appNo,
        appStatus: applicationData.value.appStatusKbn,
        appUser: sanitizeInput(applicationData.value.appUser),
        appAgCode: applicationData.value.appAgCode,
        appTitle: sanitizeInput(applicationData.value.appTitle),
        wishDate: applicationData.value.wishDate,
        appCategoryId: applicationData.value.appCategoryId,
        appCategoryName: getAppTypeName(applicationData.value.appCategoryId),
        appTempFileList: applicationData.value.appTempFileList,
        appDate: getValidStrDate(applicationData.value.appDate),
        targetAgCode: sanitizeInput(applicationData.value.targetAgCode),
        targetCompanyId: sanitizeInput(applicationData.value.targetCompanyId),
        appMemo: sanitizeInput(applicationData.value.appMemo),
        kaunetComment: sanitizeInput(applicationData.value.kaunetComment),
        kaunetMemo: sanitizeInput(applicationData.value.kaunetMemo),
        kaunetUser: sanitizeInput(applicationData.value.kaunetUser),
        operateUser: sanitizeInput(applicationData.value.operateUser),
        beforeAppStatus: beforeAppStatus.value,
        loginName: sanitizeInput(userName.value),
      };
    };

    /**************************************
     * 更新処理
     *************************************/
    const executeUpdate = async () => {
      try {
        // 申請情報更新APIを実行
        const response = await apiAuthClient.post(
          AppMgtConstants.API_URL_UPDATE,
          getRequestInput()
        );

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "申請情報", "登録/返信"));
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        throw error;
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**************************************
     * 削除処理
     *************************************/
    const executeDelete = async () => {
      try {
        // 申請情報削除APIを実行
        const response = await apiAuthClient.post(
          AppMgtConstants.API_URL_DELETE,
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            ApplicationNo: applicationData.value.appNo,
          }
        );

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "申請情報", "削除"));
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        throw error;
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**************************************
     * 申請情報再表示処理
     *************************************/
    const formDataReroad = async () => {
      // 初期情報取得API
      const response = await apiAuthClient.post(
        AppMgtConstants.API_URL_INITIAL_DISPLAY,
        {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          userId: serchUserId.value,
          agCode: serchAgCode.value,
          daihyoCode: serchDaihyoCode.value,
          applicationNo: applicationData.value.appNo,
        }
      );

      // 表示時の日時を再取得
      dispDateTime.value = response.data.dispDateTime;
      outputDebugLogs("dispDateTime:" + dispDateTime.value);

      // 申請データ設定
      applicationData.value = response.data.applicationData;

      // 申請日を表示用にフォーマット
      applicationData.value.appDate = formatDispDate(
        applicationData.value.appDate
      );

      // 変更前のステータス区分を保持
      beforeAppStatus.value = applicationData.value.appStatusKbn;
    };
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // ボタン押下時処理関連 End
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // 入力チェック関連 Start
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    /**************************************
     * 入力チェック
     *************************************/
    const validateInput = (): boolean => {
      const messageList = ref<string[]>([]);

      // 申請者名
      const sanitizeAppUser = sanitizeInput(applicationData.value.appUser);
      if (!sanitizeAppUser) {
        // 必須チェック
        messageList.value.push(formatMessage(messages.ERR_0001, "申請者名"));
      } else if (!hasNoGaiji(sanitizeAppUser)) {
        // 使用不可文字チェック
        messageList.value.push(formatMessage(messages.ERR_0026, "申請者名"));
      }

      // 申請タイトル
      const sanitizeTitle = sanitizeInput(applicationData.value.appTitle);
      if (!sanitizeTitle) {
        messageList.value.push(
          formatMessage(messages.ERR_0001, "申請タイトル")
        );
      } else if (!hasNoGaiji(sanitizeTitle)) {
        // 使用不可文字チェック
        messageList.value.push(
          formatMessage(messages.ERR_0026, "申請タイトル")
        );
      }

      // 申請カテゴリー 未選択チェック
      if (!applicationData.value.appUser) {
        messageList.value.push(formatMessage(messages.ERR_0003, "カテゴリー"));
      }

      // 添付資料または申請内容のどちらかは必須
      const sanitizeMemo = sanitizeInput(applicationData.value.appMemo);
      const isMemoEmpty = !sanitizeMemo;
      const isFileEmpty =
        (applicationData.value.appTempFileList?.length ?? 0) === 0;

      outputDebugLogs("isMemoEmpty:" + isMemoEmpty);
      outputDebugLogs("isFileEmpty:" + isFileEmpty);
      if (isMemoEmpty && isFileEmpty) {
        messageList.value.push(
          formatMessage(
            messages.ERR_0001,
            "添付資料および内容（メモ欄）のどちらか"
          )
        );
      }

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**************************************
     * 最新更新日付チェック
     *************************************/
    const checkLatestUpdDate = async (): Promise<boolean> => {
      // 新規登録時はチェックしない（True返却）
      if (processingMode.value == AppConstants.EDIT_MODE_NEW) {
        return true;
      }

      // 最新更新日付取得API
      const responce = await apiAuthClient.post(
        AppMgtConstants.API_GET_LATEST_UPD_DATE,
        {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          userId: serchUserId.value,
          agCode: serchAgCode.value,
          daihyoCode: serchDaihyoCode.value,
          applicationNo: applicationData.value.appNo,
        }
      );

      outputDebugLogs("dispDateTime:" + dispDateTime.value);
      outputDebugLogs("最新更新日付:" + responce.data.latestUpdDate);

      const dispDate = new Date(dispDateTime.value.replace(/-/g, "/"));
      const latestDate = new Date(
        responce.data.latestUpdDate.replace(/-/g, "/")
      );

      outputDebugLogs("dispDate:" + dispDate);
      outputDebugLogs("latestDate:" + latestDate);

      if (!dispDate) {
        // 画面表示時に取得できていないのでエラー
        outputDebugLogs("画面表示時に更新日時が取得できていないためエラー");
        return false;
      }

      if (!latestDate) {
        // APIから最新更新日時が取得できていないのでエラー
        outputDebugLogs("APIから最新更新日時が取得できていないのでエラー");
        return false;
      } else {
        // 最新更新日時と画面表示時の更新日時を比較
        outputDebugLogs("チェック結果：" + !(latestDate > dispDate));
        return !(latestDate > dispDate);
      }
    };

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // 入力チェック関連 End
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // ファイルアップロード関連 Start
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    /**************************************
     * ファイルアップロード実行
     * @param contentsFileList
     *************************************/
    async function executeContentsFiles(contentsFileList: ContentsFile[]) {
      let result = true;

      for (const contentsFile of contentsFileList) {
        if (contentsFile.isUpload) {
          try {
            await uploadContentsFile(contentsFile);
          } catch (error) {
            result = false;
            break;
          }
        }
      }

      return result;
    }

    /**************************************
     * ファイルアップロード処理
     * @param item
     *************************************/
    const uploadContentsFile = (contentsFile: ContentsFile): Promise<void> => {
      return new Promise((resolve, reject) => {
        if (!contentsFile.file) {
          reject("No file selected");
          return;
        }

        // ローカルストレージからトークンを取得
        const token = localStorage.getItem(AppConstants.TOKEN_SESSION_NAME);
        if (!token) {
          reject("No token found. Please log in.");
          return;
        }

        const upload = new tus.Upload(contentsFile.file, {
          // ファイルアップロードのエンドポイント
          endpoint: process.env.VUE_APP_FILE_UPLOAD_ENDPOINT,
          headers: {
            Authorization: `Bearer ${token}`,
          },
          metadata: {
            filename: contentsFile.file.name,
            filetype: contentsFile.file.type,
            agcode: serchAgCode.value,
            userid: serchUserId.value,
          },
          onError: (error) => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.error("Upload failed:", error);
            }
            reject(error);
          },
          onProgress: (bytesUploaded, bytesTotal) => {
            uploadProgress.value = Math.floor(
              (bytesUploaded / bytesTotal) * 100
            );
          },
          onSuccess: () => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.log("Upload finished:", upload.url);
            }
            // ファイルURLを保存
            contentsFile.fileUrl = upload.url;
            resolve();
          },
        });

        upload.start();
      });
    };

    /**************************************
     * コンテンツファイル削除
     * @param rowNo 行番号
     * @param trigger イベント発火元
     *************************************/
    const onRemoveContentsFile = (rowNo: number, trigger: string) => {
      switch (trigger) {
        case AppMgtConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル
          applicationData.value.appTempFileList =
            applicationData.value.appTempFileList.filter(
              (contentsFile) => contentsFile.rowNo != rowNo
            );
          break;
      }
    };

    /**************************************
     * 添付ファイルアップロード判定
     *************************************/
    const hasContentsTempFile = computed(() => {
      return applicationData.value.appTempFileList.length > 0;
    });

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // ファイルアップロード関連 End
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    /**************************************
     * AxiosErrorを処理します。
     * @param error エラー情報
     *************************************/
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, false);
    };

    /**************************************
     * ファイルリンククリックのログを出力します
     * @param fileName ファイル名
     *************************************/
    const regFileLinkClick = (fileName: string) => {
      regFileLinkClickLog(
        fileName,
        userId.value,
        agCode.value,
        pseudoAgCode.value,
        pseudoUserId.value,
        applicationData.value.appCategoryId,
        "申請管理（申請側）"
      );
    };

    /**************************************
     * 日付が有効な場合は日付、無効な場合はnullを返却します。
     *************************************/
    const getValidStrDate = (strDate: string): Date | null => {
      if (strDate) {
        return new Date(strDate);
      }
      return null;
    };

    /**************************************
     * ダイアログ関連
     *************************************/
    const showEmailAddressModal = (): Promise<EmailAddresses | null> => {
      return new Promise((resolve) => {
        emailModalResolver = resolve;
        showEmailModal.value = true;
      });
    };

    const handleEmailModalOk = (addresses: EmailAddresses) => {
      showEmailModal.value = false;
      if (emailModalResolver) {
        emailModalResolver(addresses);
        emailModalResolver = null;
      }
    };

    const handleEmailModalCancel = () => {
      showEmailModal.value = false;
      if (emailModalResolver) {
        emailModalResolver(null);
        emailModalResolver = null;
      }
    };

    /**************************************
     * メール送信関連
     *************************************/
    /**
     * AGへの通知メール送信処理
     * @param saddresses メールアドレスリスト
     */
    const sendMail = async (saddresses: EmailAddresses) => {
      await apiAuthClient.post(
        "/api/ApplicationMgtKaunet/sendMail",
        getSendmailInput(saddresses)
      );
    };

    /**
     * メール送信時のリクエスト生成
     * @param addresses メールアドレスリスト
     */
    const getSendmailInput = (addresses: EmailAddresses): object => {
      return {
        systemKbn: process.env.VUE_APP_SYSTEM_KBN,
        agCode: serchAgCode.value,
        userId: serchUserId.value,
        daihyoCode: serchDaihyoCode.value,
        appNo: applicationData.value.appNo,
        appStatus: applicationData.value.appStatusKbn,
        appUser: sanitizeInput(applicationData.value.appUser),
        appTitle: sanitizeInput(applicationData.value.appTitle),
        appAgCode: applicationData.value.appAgCode,
        wishDate: applicationData.value.wishDate,
        appCategoryId: applicationData.value.appCategoryId,
        appCategoryName: getAppTypeName(applicationData.value.appCategoryId),
        appTempFileList: applicationData.value.appTempFileList,
        appDate: getValidStrDate(applicationData.value.appDate),
        targetAgCode: applicationData.value.targetAgCode,
        targetCompanyId: applicationData.value.targetCompanyId,
        appMemo: sanitizeInput(applicationData.value.appMemo),
        kaunetComment: sanitizeInput(applicationData.value.kaunetComment),
        kaunetMemo: sanitizeInput(applicationData.value.kaunetMemo),
        kaunetUser: sanitizeInput(applicationData.value.kaunetUser),
        operateUser: sanitizeInput(applicationData.value.operateUser),
        beforeAppStatus: beforeAppStatus.value,
        mailList: addresses,
      };
    };

    /**
     * エスカレーションメール送信（メーラー起動）
     */
    const sendEscalationMail = async () => {
      // APIでメール送信用のデータを取得
      const responce = await apiAuthClient.post(
        "/api/ApplicationMgtKaunet/getEscalationMailInfo",
        getRequestInput()
      );

      const sanitaizedSubject = sanitizeInput(responce.data.mailSubject);
      const sanitaizedBody = sanitizeInput(responce.data.mailBody);
      const to = "";
      const subject = encodeURIComponent(sanitaizedSubject);
      const body = encodeURIComponent(sanitaizedBody);

      const mailto = `mailto:${to}?subject=${subject}&body=${body}`;
      //window.location.href = mailto;
      window.open(mailto, "_blank");
    };

    return {
      isInitError,
      isDataFetched,
      errorMessage,
      isKaunetAdmin,
      paramApplicationNo,
      applicationData,
      regLinkClick,
      tempFileExtensions,
      tempFileInput,
      handleContentsFileSelected,
      appCategoryList,
      isLoading,
      enableEdit,
      isVisibleCancel,
      onBack,
      onSubmit,
      onDelete,
      downloadFiles,
      regFileLinkClick,
      onContentsFileUpload,
      onRemoveContentsFile,
      AppMgtConstants,
      downloadTempFiles,
      statusList,
      emailResult,
      handleEmailModalOk,
      handleEmailModalCancel,
      showEmailModal,
      sendEscalationMail,
      txtKaunetComment,
    };
  },
});
</script>

<style scoped>
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 143px;
}
.btn-footer-large {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 200px;
}
fieldset {
  border: 2px solid #ccc;
  padding: 10px;
  margin: 10px 0;
}
legend {
  font-weight: bold;
  padding: 0 10px;
  float: initial;
  width: initial;
  margin-bottom: initial;
  font-size: initial;
  line-height: initial;
}
.form-control-title {
  text-align: center;
  background-color: lightgrey;
  border-radius: 0.25rem;
}
.form-control {
  display: inline-block;
  vertical-align: middle;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
input[type="date"] {
  width: auto;
}
table {
  border-collapse: separate;
  width: 100%;
}
.form-check-input#chkJyuyo {
  margin: -0.2rem 0.2rem 0rem 0rem;
  vertical-align: inherit;
}
.form-check-input[name="hyojiTaisho"] {
  margin: 0rem 0.2rem 0rem 0rem;
  vertical-align: inherit;
}
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
td .btn-sm {
  width: 25px;
}
.file-upload {
  display: inline-block;
}
.vertical-align-top {
  vertical-align: top;
}

.resizable-textarea {
  width: 98%;
  resize: both; /* 縦横サイズ変更可能 */
  padding: 8px;
  font-size: 16px;
  line-height: 1.5;
  margin-left: 2px;
}

/* ★新規 CSS － 既存を壊さず override */
.osg-file-item {
  /* 行をフレックス化 */
  display: flex;
  align-items: center; /* 垂直中央に */
  gap: 6px;
}

.osg-file-item .com_dl_button2 {
  /* ボタンだけ下駄を履かせる */
  vertical-align: middle; /* baseline → middle へ変更 */
  /* 追加で余白が欲しければ */
  margin-left: 4px;
}

.osg-files-cell .osg-file-row {
  display: flex; /* 横並び */
  align-items: center; /* 縦中央揃え */
  gap: 4px; /* アイテム間の隙間調整 ※任意 */
}

.osg-files-cell .osg-file-row__btn {
  margin-left: auto; /* 右端に押し出す */
  vertical-align: middle; /* 念のため行中央に */
}
</style>
